import { Course } from '../../types'

interface VideoHistory {
  time: number
  video_id: string
}

interface CourseHistory {
  course_id: string
  time: number
  videos: Array<VideoHistory>
}

interface StatisticsState {
  courseHistoryStats: {
    all_courses_video_time_watched?: CourseHistory
  }
  coursesForHistory: Array<Course>
  monthlyStats: { time_watched?: { value: number } }
  yearlyStats: {
    courses_viewed?: { time_watched: { value: number } }
    time_watched?: { time_watched: { value: number } }
    time_watched_chart?: { [key: string]: number }
    videos_watched?: { time_watched: { value: number } }
  }
}

const state: StatisticsState = {
  courseHistoryStats: {},
  coursesForHistory: [],
  monthlyStats: {},
  yearlyStats: {},
}

export { StatisticsState, state }
